import { ORIGENS_PRODUTO, normalizarOrigemProduto } from '@/utils/origensProduto'

export { ORIGENS_PRODUTO }
export const TIPOS_PRODUTO = [
  ['GERAL', 'Geral'], ['MATERIA_PRIMA', 'Matéria prima'], ['GRADE', 'Grade'],
  ['BALANCA', 'Balança'], ['ACABADO', 'Acabado'], ['KIT', 'Kit'],
  ['VEICULO', 'Veículo'], ['ARMAMENTO', 'Armamento'], ['USO_CONSUMO', 'Uso e Consumo']
].map(([value, label]) => ({ value, label }))

export const CAMPOS_GENERICOS_PRODUTO = [
  ['sku', 'Referência/SKU'], ['grupo', 'Grupo'], ['subgrupo', 'Subgrupo'], ['marca', 'Marca'],
  ['setor', 'Setor'], ['observacoes', 'Observações'], ['custoMedio', 'Custo médio'],
  ['margemLucro', 'Margem de lucro'], ['dimensoes', 'Dimensões'], ['ecommerce', 'E-commerce'],
  ['codigosBarra', 'Códigos de barras'], ['infoAdicionalFiscal', 'Informação adicional fiscal'], ['fotos', 'Foto do produto']
].map(([field, label]) => ({ field, label }))
export const CORES_MARGEM_PADRAO = { corAbaixo: '#DC3545', corIntermediaria: '#FFC107', corIdeal: '#198754' }
export const PADROES_NOVO_PRODUTO = { tipoProduto: 'GERAL', tributacaoId: null, margemLucro: null, origemTributaria: null }
export const corHexValida = value => /^#[\da-f]{6}$/i.test(String(value || ''))
const percentual = (value, fallback) => value != null && String(value).trim() !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 ? Number(value) : fallback

export function configuracaoCadastroProdutos(settings = {}, legado = {}) {
  const rotina = settings?.['produtos-servicos'] || {}
  const p = rotina.precificacao || {}, d = rotina.padroes || legado.padroes || {}
  const minima = percentual(p.margemMinima, percentual(legado.minima, 20))
  const ideal = Math.max(minima, percentual(p.margemIdeal, percentual(legado.ideal, 40)))
  const cores = Object.fromEntries(Object.entries(CORES_MARGEM_PADRAO).map(([key, value]) => [key, corHexValida(p[key] ?? legado[key]) ? String(p[key] ?? legado[key]).toUpperCase() : value]))
  return {
    precificacao: { margemMinima: minima, margemIdeal: ideal, ...cores },
    padroes: {
      tipoProduto: TIPOS_PRODUTO.some(t => t.value === d.tipoProduto) ? d.tipoProduto : 'GERAL',
      tributacaoId: d.tributacaoId === '' || d.tributacaoId == null ? null : d.tributacaoId,
      margemLucro: percentual(d.margemLucro, null),
      origemTributaria: normalizarOrigemProduto(d.origemTributaria)
    }
  }
}

export function preferenciasCadastroProdutos(config) {
  return { minima: config.precificacao.margemMinima, ideal: config.precificacao.margemIdeal,
    ...Object.fromEntries(Object.keys(CORES_MARGEM_PADRAO).map(key => [key, config.precificacao[key]])), padroes: config.padroes }
}

export function configuracaoProdutosConfirmada(settings, form) {
  const actual = configuracaoCadastroProdutos(settings), expected = configuracaoCadastroProdutos({ 'produtos-servicos': form })
  // IDs podem voltar como texto; demais valores já estão normalizados, inclusive origem zero.
  return JSON.stringify({ ...actual, padroes: { ...actual.padroes, tributacaoId: actual.padroes.tributacaoId == null ? null : String(actual.padroes.tributacaoId) } }) ===
    JSON.stringify({ ...expected, padroes: { ...expected.padroes, tributacaoId: expected.padroes.tributacaoId == null ? null : String(expected.padroes.tributacaoId) } })
}

export function camposGenericosProduto(config = []) {
  return CAMPOS_GENERICOS_PRODUTO.map(({ field }) => ({ field, visible: config.find(item => item.field === field)?.visible !== false }))
}

export function validarConfiguracaoProdutos(form) {
  const p = form.precificacao || {}, d = form.padroes || {}
  if ([p.margemMinima, p.margemIdeal].some(v => v == null || v === '' || !Number.isFinite(Number(v)) || Number(v) < 0) || Number(p.margemIdeal) < Number(p.margemMinima)) return 'A margem ideal deve ser igual ou maior que a mínima, sem valores negativos.'
  if (Object.keys(CORES_MARGEM_PADRAO).some(key => !corHexValida(p[key]))) return 'Informe as três cores da margem no formato #RRGGBB.'
  if (!TIPOS_PRODUTO.some(t => t.value === d.tipoProduto)) return 'Selecione o tipo padrão de produto.'
  if (d.margemLucro != null && d.margemLucro !== '' && percentual(d.margemLucro, null) === null) return 'Informe uma margem padrão válida e não negativa.'
  if (d.origemTributaria != null && d.origemTributaria !== '' && normalizarOrigemProduto(d.origemTributaria) == null) return 'Selecione uma origem tributária válida.'
  return ''
}

export function estiloMargemProduto(custo, venda, preferencias = {}) {
  if (!(Number(custo) > 0)) return {}
  const margem = Number((((Number(venda) || 0) / Number(custo) - 1) * 100).toFixed(2))
  const key = margem < Number(preferencias.minima ?? 20) ? 'corAbaixo' : margem < Number(preferencias.ideal ?? 40) ? 'corIntermediaria' : 'corIdeal'
  const cor = corHexValida(preferencias[key]) ? preferencias[key] : CORES_MARGEM_PADRAO[key]
  const rgb = [1, 3, 5].map(i => parseInt(cor.slice(i, i + 2), 16) / 255).map(v => v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4)
  const luminancia = rgb[0] * 0.2126 + rgb[1] * 0.7152 + rgb[2] * 0.0722
  return { '--produto-cor-margem': cor, '--produto-texto-margem': luminancia > 0.179 ? '#000000' : '#FFFFFF' }
}
